export default __webpack_public_path__ + "cadd7d80cd4ed1c6aadc70c9530396d4.svg";